import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Button, message, Steps, Switch, Popconfirm, Tag, Divider } from "antd";

import storageUtils from "../../utils/storageUtils";
import {
  req_single_ams_alumni,
  req_add_gqm_alumniApplyModify,
} from "../../api";

const { Step } = Steps;

class AlumniApplyModify extends Component {
  static propTypes = {
    alumni: PropTypes.object.isRequired,
  };
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    loading: false,
    workstatus: false,
    current: 0,
    steps: [
      {
        title: "基本資料",
        description: "姓名、生活狀況、校友會聲明等資料填寫",
      },
      {
        title: "連絡方式",
        description: "電話、電子郵件及地址等資料填寫",
      },
      {
        title: "現況說明",
        description: "若就業或升學，填寫相關資訊",
      },
      {
        title: "最高學歷",
        description: "填寫目前最高學歷",
      },
    ],
    lifestatus: 0,
    agreeAssociationSetInfo: "YES",
    item: {},
    apply: {
      ProcessStatus: "WAIT",
      TwId: "",
      AlumniName: "",
      NowStatusSource: "",
      NowStatusPrimary: "",
      NowStatusSecondary: "",
      NowStatusPrimarySecondary: "",
      MobilePrincipal: "",
      MobileSpare: "",
      TelephonePrincipal: "",
      TelephoneSpare: "",
      EmailPrincipal: "",
      EmailSpare: "",
      MailingAddress: "",
      ResidentAddress: "",
      LastFinalDegree: "",
      LastFinalUniversity: "",
      LastFinalDepartmentName: "",
      LastFinalMajor: "",
      ContinueLearnLocation: "",
      ContinueLearnUniversity: "",
      ContinueLearnDepartmentName: "",
      ContinueLearnDegree: "",
      ContinueLearnDivision: "",
      JobType: "",
      JobCompany: "",
      JobDepartment: "",
      JobTitle: "",
      JobTelephone: "",
      JobAddress: "",
      JobFax: "",
      JobFirstSalary: "0",
      CurrentSalary: "0",
      JobBossName: "",
      JobBossEmail: "",
      AgreePrivacy: "YES",
      AgreeAssociationSetInfo: "YES",
      AgreeLabourDepartSendInfo: "YES",
    },
    finishPage: false,
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAgree = this.handleAgree.bind(this);
    this.handleDisagree = this.handleDisagree.bind(this);
  }

  UNSAFE_componentWillMount() {}

  componentDidMount() {
    this.api_single_item();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_single_item = async () => {
    const { token } = this.props.user;
    const { TwId } = this.props.alumni;
    this.setState({ loading: true });
    const result = await req_single_ams_alumni(TwId, token);
    this.setState({ loading: false });
    const item = result;
    this.setState({ item });

    const apply = this.state.apply;
    apply.TwId = result.TwId;
    apply.AlumniName = result.AlumniName;
    apply.NowStatusPrimary = result.NowStatusPrimary;
    apply.NowStatusPrimarySecondary = result.NowStatusPrimarySecondary;
    this.handleLifeStatus(result.NowStatusPrimarySecondary);
    this.setState({ apply });
  };

  api_edit_item = async (item) => {
    const result = await req_add_gqm_alumniApplyModify(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      // console.log(result)
      message.success("謝謝配合調查，請繼續您的問卷調查作業");
      this.api_single_item();
    } else {
      message.error(result.message);
    }
  };

  ///////////////////////////////////////////////////////////

  handleChange(event) {
    const { apply } = this.state;
    //console.log(event)
    Object.keys(apply).forEach((propertyName) => {
      if (event.target.id === "AgreePrivacy" && event.target.value !== null) {
        // Checkbox
        apply.AgreePrivacy = event.target.checked;
      } else {
        if (event.target.id === propertyName && event.target.value !== null) {
          apply[propertyName] = event.target.value.trim();
        }
        if (event.target.id === "NowStatusPrimarySecondary") {
          this.handleLifeStatus(event.target.value.trim());
        }
      }
    });
    this.setState({ apply });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { agreeAssociationSetInfo, current, steps } = this.state;
    const row = this.state.apply;
    const errors = [];

    if (current === steps.length - 1) {
      if (!row.AlumniName.trim()) {
        errors.push("姓名未填");
      }
      if (!row.MobilePrincipal.trim()) {
        errors.push("行動電話未填");
      }
      if (!row.MailingAddress.trim()) {
        errors.push("通訊地址未填");
      }

      if (errors.length === 0) {
        row.TelephoneSurveyOperator = storageUtils.getUser().userCode;
        row.NowStatusModifyOperator = storageUtils.getUser().userCode;
        row.NowStatusSource = "自行異動";
        row.NowStatusPrimary = row.NowStatusPrimarySecondary.substr(0, 2);
        row.NowStatusSecondary = row.NowStatusPrimarySecondary.substr(2);
        row.AgreeAssociationSetInfo = agreeAssociationSetInfo;
        row.condition = "SELFOPERATOR";
        //console.log(row);
        this.api_edit_item(row);
      } else {
        let info = errors.join(",");
        message.error(info);
      }
    }
  }

  handleAgree() {
    const row = this.state.item;
    row.AgreePrivacy = true;
    this.setState({ item: row });
  }

  handleDisagree() {
    const row = this.state.item;
    row.AgreePrivacy = false;
    this.setState({ item: row });
  }

  handleLifeStatus = (status) => {
    var lifestatus = 0;
    switch (status) {
      case "就業":
      case "就業就業":
      case "就業在職進修":
      case "就業自行創業":
        lifestatus = 1;
        break;
      case "升學升學":
      case "留學留學":
        lifestatus = 2;
        break;
      default:
        console.log(`Sorry`);
    }
    this.setState({ lifestatus });
  };

  next = () => {
    const { current } = this.state;
    this.setState({ current: current + 1 });
  };

  prev = () => {
    const { current } = this.state;
    this.setState({ current: current - 1 });
  };

  onSwitchChange = (checked) => {
    //console.log(checked);
    if (!checked) {
      this.setState({ agreeAssociationSetInfo: "NO" });
      //console.log("不同意");
    } else {
      this.setState({ agreeAssociationSetInfo: "YES" });
      //console.log("同意");
    }
  };

  /////////////////////////////
  render() {
    const {
      TwId,
      AlumniName,
      NowStatusPrimarySecondary,
      MobilePrincipal,
      // MobileSpare,
      TelephonePrincipal,
      // TelephoneSpare,
      EmailPrincipal,
      // EmailSpare,
      MailingAddress,
      // ResidentAddress,
      JobType,
      JobTitle,
      JobFirstSalary,
      CurrentSalary,
      JobCompany,
      JobDepartment,
      JobTelephone,
      // JobFax,
      JobAddress,
      JobBossName,
      JobBossEmail,
      LastFinalDegree,
      LastFinalUniversity,
      LastFinalDepartmentName,
      // LastFinalMajor,
      ContinueLearnUniversity,
      ContinueLearnDepartmentName,
      ContinueLearnDegree,
      ContinueLearnDivision,
      // ContinueLearnLocation,
    } = this.state.apply;
    const { current, steps, lifestatus, finishPage } = this.state;
    return finishPage ? (
      <div style={{ textAlign: "center", margin: "5px" }}>
        <Tag color="magenta" style={{ fontSize: "1.5em" }}>
          感謝您的配合!!
        </Tag>
      </div>
    ) : (
      <form onSubmit={this.handleSubmit}>
        <>
          <div
            style={{
              backgroundColor: "#FDF9F8",
              border: "1px solid #F3F3F3",
              marginBottom: "1px",
            }}
          >
            <Steps current={current} direction="horizontal" size="small">
              {steps.map((item) => (
                <Step
                  key={item.title}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </Steps>
          </div>
          <div
            className="steps-content"
            style={{ border: "1px solid #F3F3F3" }}
          >
            {current === 0 ? (
              <>
                <div className="form-row">
                  <div className="col-lg-3">
                    <div className="form-group">
                      <label>身分證字號</label>
                      <input
                        type="text"
                        className="form-control text-primary"
                        name="TwId"
                        id="TwId"
                        defaultValue={TwId}
                        disabled={true}
                      />
                    </div>
                  </div>
                  <div className="col-lg-9">
                    <div className="form-group">
                      <label>
                        <span
                          className="text-danger"
                          style={{ fontWeight: "bold", fontSize: "1.2em" }}
                        >
                          *
                        </span>
                        姓名
                      </label>
                      <input
                        type="text"
                        className="form-control text-primary"
                        name="AlumniName"
                        id="AlumniName"
                        aria-describedby="AlumniName"
                        placeholder="請輸入姓名"
                        defaultValue={AlumniName}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-row" style={{ textAlign: "center" }}>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <Switch
                        checkedChildren="同意收到本校校友會不定期相關資訊"
                        unCheckedChildren="本人無意願接收本校校友會資訊"
                        defaultChecked
                        onChange={this.onSwitchChange}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            {current === 1 ? (
              <>
                <div className="form-row">
                  <div className="col-lg">
                    <div className="form-group">
                      <label>
                        <span
                          className="text-danger"
                          style={{ fontWeight: "bold", fontSize: "1.2em" }}
                        >
                          *
                        </span>
                        行動電話
                      </label>
                      <input
                        type="text"
                        className="form-control text-primary"
                        name="MobilePrincipal"
                        id="MobilePrincipal"
                        placeholder="請輸入您常用行動電話"
                        defaultValue={MobilePrincipal}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg">
                    <div className="form-group">
                      <label>電子郵件</label>
                      <input
                        type="email"
                        className="form-control text-primary"
                        name="EmailPrincipal"
                        id="EmailPrincipal"
                        aria-describedby="emailHelp"
                        placeholder="請輸入您常用電子郵件"
                        defaultValue={EmailPrincipal}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-lg-8">
                    <div className="form-group">
                      <label>
                        <span
                          className="text-danger"
                          style={{ fontWeight: "bold", fontSize: "1.2em" }}
                        >
                          *
                        </span>
                        通訊地址
                      </label>
                      <input
                        type="text"
                        className="form-control text-primary"
                        name="MailingAddress"
                        id="MailingAddress"
                        placeholder="請輸入您目前通訊地址"
                        defaultValue={MailingAddress}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg">
                    <div className="form-group">
                      <label>通訊地址室內電話</label>
                      <input
                        type="text"
                        className="form-control text-primary"
                        name="TelephonePrincipal"
                        id="TelephonePrincipal"
                        placeholder="請輸入您通訊地址室內電話"
                        defaultValue={TelephonePrincipal}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            {current === 2 ? (
              <>
                <div className="form-row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label>生活狀況</label>
                      <select
                        name="NowStatusPrimarySecondary"
                        id="NowStatusPrimarySecondary"
                        className="custom-select mb-3 text-success"
                        defaultValue={NowStatusPrimarySecondary}
                        onChange={this.handleChange}
                        key={NowStatusPrimarySecondary}
                      >
                        {" "}
                        <option value="就業就業">就業</option>
                        <option value="就業在職進修">就業(在職進修)</option>
                        <option value="就業自行創業">就業(自行創業)</option>
                        <option value="其他待業">待業</option>
                        <option value="服役服役">服役</option>
                        <option value="升學升學">升學</option>
                        <option value="留學留學">留學</option>
                        <option value="其他遊學">遊學</option>
                        <option value="其他家管">家管</option>
                        <option value="其他教育實習">教育實習</option>
                        <option value="其他準備考試">準備考試</option>
                      </select>
                    </div>
                  </div>
                </div>
                {lifestatus === 0 ? (
                  <>
                    {" "}
                    <div className="form-row">
                      <div className="col-lg">
                        <div className="form-group">
                          <span>無就業或進修，請按[下一頁]</span>
                        </div>
                      </div>
                    </div>
                  </>
                ) : lifestatus === 1 ? (
                  <>
                    {" "}
                    <div className="form-row">
                      <div className="col-lg-2">
                        <div className="form-group">
                          <label>主要工作型態</label>
                          <select
                            name="JobType"
                            id="JobType"
                            className="custom-select mb-3 text-success"
                            defaultValue={JobType}
                            onChange={this.handleChange}
                            key={JobType}
                          >
                            {" "}
                            <option value="">請選擇</option>
                            <option value="全職">全職</option>
                            <option value="兼職">兼職</option>
                            <option value="正職">正職</option>
                            <option value="約聘">約聘</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>工作職稱</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobTitle"
                            id="JobTitle"
                            placeholder="負責人/經理/業務...."
                            defaultValue={JobTitle}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="form-group">
                          <label>第一份薪水金額</label>
                          <input
                            type="number"
                            className="form-control text-primary"
                            name="JobFirstSalary"
                            id="JobFirstSalary"
                            placeholder="僅填數字"
                            defaultValue={JobFirstSalary}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="form-group">
                          <label>月均薪金額</label>
                          <input
                            type="number"
                            className="form-control text-primary"
                            name="CurrentSalary"
                            id="CurrentSalary"
                            placeholder="僅填數字"
                            defaultValue={CurrentSalary}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <Divider orientation="left" plain>
                      機構行號資訊
                    </Divider>
                    <div className="form-row">
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>機構名稱</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobCompany"
                            id="JobCompany"
                            placeholder="政府組織/公司企業/店名/工作室 名稱"
                            defaultValue={JobCompany}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-2">
                        <div className="form-group">
                          <label>隸屬部門</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobDepartment"
                            id="JobDepartment"
                            placeholder="部門名稱"
                            defaultValue={JobDepartment}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>聯絡電話</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobTelephone"
                            id="JobTelephone"
                            placeholder="政府組織/公司企業/店名/工作室 電話"
                            defaultValue={JobTelephone}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label>聯絡地址</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobAddress"
                            id="JobAddress"
                            placeholder="政府組織/公司企業/店名/工作室 地址"
                            defaultValue={JobAddress}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-lg-5">
                        <div className="form-group">
                          <label>負責人(或主管)姓名</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobBossName"
                            id="JobBossName"
                            placeholder="負責人/主管/雇主 姓名"
                            defaultValue={JobBossName}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg">
                        <div className="form-group">
                          <label>負責人(或主管)電子郵件</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="JobBossEmail"
                            id="JobBossEmail"
                            placeholder="負責人/主管/雇主 電子郵件"
                            defaultValue={JobBossEmail}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : lifestatus === 2 ? (
                  <>
                    {" "}
                    <div className="form-row">
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>進修學校學位</label>
                          <select
                            name="ContinueLearnDegree"
                            id="ContinueLearnDegree"
                            className="custom-select mb-3 text-success"
                            defaultValue={ContinueLearnDegree}
                            onChange={this.handleChange}
                            key={ContinueLearnDegree}
                          >
                            {" "}
                            <option value="">請選擇</option>
                            <option value="博士">博士</option>
                            <option value="碩士">碩士</option>
                            <option value="學士">學士</option>
                            <option value="副學士">副學士</option>
                            <option value="專科">專科</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>進修學校部別</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="ContinueLearnDivision"
                            id="ContinueLearnDivision"
                            placeholder="例：日間部/進修部..."
                            defaultValue={ContinueLearnDivision}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>進修學校校名</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="ContinueLearnUniversity"
                            id="ContinueLearnUniversity"
                            placeholder="例：ＯＯＯＯ大學"
                            defaultValue={ContinueLearnUniversity}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label>進修學校學系</label>
                          <input
                            type="text"
                            className="form-control text-primary"
                            name="ContinueLearnDepartmentName"
                            id="ContinueLearnDepartmentName"
                            placeholder="例：商品設計系/音樂系..."
                            defaultValue={ContinueLearnDepartmentName}
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </>
            ) : (
              ""
            )}
            {current === 3 ? (
              <>
                {" "}
                <div className="form-row">
                  <div className="col-lg-3">
                    <div className="form-group">
                      <label>最高學歷學位</label>
                      <select
                        name="LastFinalDegree"
                        id="LastFinalDegree"
                        className="custom-select mb-3 text-success"
                        defaultValue={LastFinalDegree}
                        onChange={this.handleChange}
                        key={LastFinalDegree}
                      >
                        {" "}
                        <option value="">請選擇</option>
                        <option value="博士">博士</option>
                        <option value="碩士">碩士</option>
                        <option value="學士">學士</option>
                        <option value="副學士">副學士</option>
                        <option value="專科">專科</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label>最高學歷學校名稱</label>
                      <input
                        type="text"
                        className="form-control text-primary"
                        name="LastFinalUniversity"
                        id="LastFinalUniversity"
                        placeholder="例：ＯＯＯＯ大學"
                        defaultValue={LastFinalUniversity}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="form-group">
                      <label>最高學歷學系</label>
                      <input
                        type="text"
                        className="form-control text-primary"
                        name="LastFinalDepartmentName"
                        id="LastFinalDepartmentName"
                        placeholder="例：商品設計系/音樂系..."
                        defaultValue={LastFinalDepartmentName}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
          <div className="steps-action" style={{ marginTop: "4px" }}>
            {current < steps.length - 1 && (
              <button className="btn btn-primary btn-sm" onClick={this.next}>
                下一頁
              </button>
            )}
            {current === steps.length - 1 && (
              <>
                <Popconfirm
                  title="因應個人資料保護法及本校個人資料管理規定，本校在向您蒐集個人資料之前，依法向您告知下列事項，當您勾選「我同意」，表示您已閱讀、瞭解並同意接受本同意書之所有內容：
                                    一、蒐集目的及類別
                                    為提供活動各項通知服務、報名資料確認、寄送本校或產業相關活動訊息及本校內部管理使用之蒐集目的，而須獲取您下列個人資料類別： 姓名、電話、E-mail 或其他得以直接或間接識別您個人之資料。
                                    二、個人資料利用之期間、地區、對象及方式
                                    您的個人資料，除涉及國際業務或活動外，僅供本校及活動協辦單位於中華民國領域，於上述蒐集目的之必要合理範圍內加以利用至前述蒐集目的消失時為止。
                                    
                                    三、當事人權利行使
                                    依據個人資料保護法第3條規定，您可向本校請求查詢或閱覽、製給複製本、補充或更正、停止蒐集/處理/利用或刪除您的個人資料。
                                    
                                    四、不提供個人資料之權益影響
                                    如您不提供或未提供正確之個人資料，或要求停止蒐集/處理/利用/刪除個人資料、服務訊息的取消訂閱，本校將無法為您提供蒐集目的之相關服務。
                                    
                                    五、各項通知服務、相關訊息之停止寄送，或違反本個資聲明之行為。您可於上班時間聯繫承辦人（電話06-2535642，分機 227、229）反映。
                                     
                                    個人資料同意提供：
                                    一、本人確已閱讀並瞭解上述告知事項，並勾選「我同意」授權貴校於所列目的之必要合理範圍內，蒐集、處理及利用本人之個人資料。
                                    二、本人瞭解此同意書符合個人資料保護法及相關法規之要求，並提供予貴校留存及日後查證使用。"
                  cancelText="了解"
                >
                  <Button type="link">
                    註：送出即同意[蒐集個資告知事項暨個人資料]宣告
                  </Button>
                </Popconfirm>
                <button type="submit" className="btn btn-success btn-sm">
                  送出
                </button>
              </>
            )}
            {current > 0 && (
              <button
                className="btn btn-light btn-sm"
                style={{
                  margin: "0 8px",
                }}
                onClick={this.prev}
              >
                上一頁
              </button>
            )}
          </div>
        </>
      </form>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(AlumniApplyModify);
